import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  
  // Complete handleScroll function with buffer zone
  const handleScroll = () => {
    // Get the hero section
    const heroSection = document.querySelector('.hero-overlay');
    
    if (heroSection) {
      // Get the bottom position of the hero section
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      
      // Define buffer zone (adjust this value as needed)
      const bufferZone = 500; // pixels before the end of hero section
      
      // Check if we've scrolled to the buffer zone
      if (heroBottom <= bufferZone) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    } else {
      // If we're on a page without a hero section, use a simple scroll threshold
      if (window.scrollY > 500) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
  };
  
  // Set up scroll listener - using a different approach to avoid dependency issues
  useEffect(() => {
    // Define the throttle function inside the effect to avoid dependency issues
    let isScrolling = false;
    const throttledScroll = () => {
      if (!isScrolling) {
        isScrolling = true;
        window.requestAnimationFrame(() => {
          handleScroll();
          isScrolling = false;
        });
      }
    };
    
    window.addEventListener('scroll', throttledScroll);
    
    // Check immediately on mount to set proper state
    handleScroll();
    
    // Clean up
    return () => {
      window.removeEventListener('scroll', throttledScroll);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // We're using eslint-disable to prevent the dependency warning
  
  return (
    <>
      {/* Placeholder div to reserve space */}
      <div className="header-placeholder"></div>
      
      <header className={`header ${scrolled ? 'header-scrolled' : ''}`}>
        <div className="container">
          <div className="header-content">
            {/* Floating Brand Element */}
            <div className="brand-floating">
              <Link to="/" className="brand-link">
                <div className="brand-vertical">
                  <span className="brand-name">sterling rain</span>
                </div>
                <span className="brand-subtitle">projects ltd.</span>
              </Link>
            </div>
            
            {/* Navigation */}
            <nav className="main-nav">
              <ul className="nav-list">
                <li className="nav-item">
                  <Link 
                    to="/" 
                    className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                  >
                    home.
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    to="/work" 
                    className={`nav-link ${location.pathname === '/work' ? 'active' : ''}`}
                  >
                    work.
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    to="/about" 
                    className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
                  >
                    about.
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    to="/contact" 
                    className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
                  >
                    contact.
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;